import React from 'react'
import { useTranslation } from '@mc/i18n'
import { BenefitTrans, TableHeader, useTiersInfo } from '@mc/plans-ui'
import { BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE } from '../../i18n'

export const MatrixHeader = () => {
  const { individual, duo, family } = useTiersInfo()

  return (
    <>
      <TableHeader.Titles>
        <TableHeader.IndividualTitle>
          {individual.displayName}
        </TableHeader.IndividualTitle>
        <TableHeader.DuoTitle>{duo.displayName}</TableHeader.DuoTitle>
        <TableHeader.FamilyTitle>{family.displayName}</TableHeader.FamilyTitle>
      </TableHeader.Titles>

      <TableHeader.Actions>
        <RegularActions />
      </TableHeader.Actions>
    </>
  )
}

const RegularActions = () => {
  const { t } = useTranslation(BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE)
  const { individual, duo, family } = useTiersInfo()

  return (
    <>
      <TableHeader.IndividualAction
        description={
          <>
            <BenefitTrans
              ns={BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE}
              i18nKey='matrix.headers.devicesInfo'
              tier={individual}
              name='concurrent_devices'
            />
            <br />
            <BenefitTrans
              ns={BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE}
              i18nKey='matrix.headers.offlineMode'
              tier={individual}
              name='offline_download'
              defaultValue={false}
            />
          </>
        }
        label={t('matrix.headers.cta.label', {
          plan: individual.displayName,
        })}
        selectedLabel={t('matrix.headers.cta.selected')}
        unselectedLabel={t('matrix.headers.cta.select')}
      />
      <TableHeader.DuoAction
        description={
          <>
            <BenefitTrans
              ns={BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE}
              i18nKey='matrix.headers.devicesInfo'
              tier={duo}
              name='concurrent_devices'
            />
            <br />
            <BenefitTrans
              ns={BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE}
              i18nKey='matrix.headers.offlineMode'
              tier={duo}
              name='offline_download'
            />
          </>
        }
        label={t('matrix.headers.cta.label', {
          plan: duo.displayName,
        })}
        selectedLabel={t('matrix.headers.cta.selected')}
        unselectedLabel={t('matrix.headers.cta.select')}
      />
      <TableHeader.FamilyAction
        description={
          <>
            <BenefitTrans
              ns={BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE}
              i18nKey='matrix.headers.devicesInfo'
              tier={family}
              name='concurrent_devices'
            />
            <br />
            <BenefitTrans
              ns={BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE}
              i18nKey='matrix.headers.offlineMode'
              tier={family}
              name='offline_download'
            />
            <br />
            {t('matrix.headers.certificate')}
          </>
        }
        label={t('matrix.headers.cta.label', {
          plan: family.displayName,
        })}
        selectedLabel={t('matrix.headers.cta.selected')}
        unselectedLabel={t('matrix.headers.cta.select')}
        badge={t('matrix.headers.bestValue')}
      />
    </>
  )
}
